import { useContext } from "react";
//
import execute from "@beeldit/core/services/execute";
import { TestEmailContext } from "./TestEmailContext";

function useExecuteGenerateEventSessions() {
  const { modelId } = useContext(TestEmailContext);
  return (onSuccess: any) => {
    execute(`crm_notifications/${modelId}/test-email`, {})
      .then((response: any) => {
        onSuccess(response.data);
      })
      .catch((error: any) => {
        console.error("Error fetching data:", error);
      });
  };
}

export default useExecuteGenerateEventSessions;
